import { DownloadIcon, PersonIcon } from "@radix-ui/react-icons";

import { SimpleTooltip } from "@/components/ui/tooltip";
import { CustomNodeHistoryItem } from "@/lib/api";
import { formatBigNumber, cn } from "@/lib/utils";

export function CustomNodeInstallStats({
  size = "md",
  ...props
}: CustomNodeHistoryItem & { size?: "sm" | "md" | "lg" }) {
  const textSize =
    size === "sm" ? "text-xs" : size === "md" ? "text-sm" : "text-xl";
  const iconSize =
    size === "sm" ? "h-3 w-3" : size === "md" ? "h-4 w-4" : "h-6 w-6";
  const gapSize = size === "sm" ? "gap-1" : size === "md" ? "gap-2" : "gap-4";

  return (
    <div className={cn("flex items-center shrink-0", gapSize)}>
      <SimpleTooltip message="Total Installs">
        <div
          className={cn("text-slate-dim", textSize, "flex items-center gap-1")}
        >
          <DownloadIcon className={iconSize} />
          {formatBigNumber(props.installs)}
        </div>
      </SimpleTooltip>
      <SimpleTooltip message="Users">
        <div
          className={cn("text-slate-dim", textSize, "flex items-center gap-1")}
        >
          <PersonIcon className={iconSize} />
          {formatBigNumber(props.unique_user_installs)}
        </div>
      </SimpleTooltip>
    </div>
  );
}
